import gql from 'graphql-tag'

export default gql`
query getInternalDump($typeValue: String! $dumpDate: String! ){
    getInternalDump(typeValue: $typeValue dumpDate: $dumpDate){
        typeValue
        dumpDate
        dumpData
    }
}`